<script setup lang="ts">
// 顶级 RouterView。布局由 router 配置的 DefaultLayout 决定（除登录页外）。
</script>

<template>
  <RouterView />
</template>
